import useTranslation from "next-translate/useTranslation";
import React from "react";
import PrixDeBien from "./CalculeMensualCharts/ChartResult";
import RevenuMensuel from "./RevenuMensuelComponent/RevenuMensuel";
import style from "./style.module.css";

function CalculezMensual() {
  const { t, lang } = useTranslation("creditImmo");

  return (
    <div className={style.container}>
      <RevenuMensuel t={t} />
      <PrixDeBien t={t} lang={lang} />
    </div>
  );
}

export default CalculezMensual;
